import React from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import MaterialTable from 'material-table';
import {alertActions, grupoActions, utilActions} from '../../_actions';
import {Role, RoleID, tengoRol, UserDP} from '../../_helpers';
import Moment from 'react-moment';
import {Field, Form, Formik} from 'formik';
import {userService} from '../../_services';
import authService from '../../_services/authService';
import {FormUsuarioAdmin} from '../admin/forms/FormUsuarioAdmin';
import {FormAsignarEquipoUsuario} from '../admin/forms/FormAsignarEquipoUsuario';

const tableRef4 = React.createRef();

class MisUsuarios extends React.Component {

    componentDidMount() {
    }

    handleMasInfo = (usuario) => {
        this.setState({
            showUsuario: true,
            usuario: usuario
        });
    };

    buscarData = (query, completo) => {
        const newThis = this;
        return new Promise((resolve, reject) => {
            let nuevo = {
                infoTabla: {
                    resultadoCompleto: completo,
                    search: query.search,
                    page: query.page,
                    limit: query.pageSize,
                    skip: Math.floor((query.pageSize * query.page)),
                    orderBy: query.orderBy ? query.orderBy : '',
                    order: query.orderDirection ? query.orderDirection : ''
                }
            };

            if (!completo)
                newThis.setState({nuevo: nuevo});

            let dataBusqueda = newThis.state.values ? Object.assign(newThis.state.values, nuevo) : nuevo;

            dataBusqueda.empresa = {
                id: authService.getLoggedUser().detail.empresa.id
            }

            userService.buscarUsuarios(dataBusqueda)
                .then(
                    data => {
                        resolve({
                            data: data.listado ? data.listado.listado : [],
                            page: query.page,
                            totalCount: data.listado ? data.listado.total : 0
                        });

                        this.actualizarPageSize(query.pageSize);
                    }
                );
        })
    }

    actualizarPageSize = (newPageSIze) => {
        if (tableRef4.current) {
            tableRef4.current.dataManager.changePageSize(newPageSIze)
        }
    };


    asignarEquipo = (usuario) => {
        this.setState({showEquipo: true, usuario: usuario});
    };

    cerrarAlert = () => {
        this.setState({alert: undefined, showMasInfoUsuario: false});
    }

    handleClose = () => {
        this.setState({showAgregarUsuario: false, showUsuario: false, showEquipo: false});
    };

    actualizar = () => {
        tableRef4.current && tableRef4.current.onQueryChange();
    }

    onDelete = (user, equipo) => {
        console.log(user, equipo)
        let body = {
            userId: user.id,
            equipoId: equipo.id
        }

        userService.deleteEquipoFromUsuario(body)
        .then(
            data => {
                this.actualizar();
                this.props.enviarSuccess("El equipo ha sido eliminado del usuario.");
            }
        );
    }

    state = {
        showAgregarUsuario: false,
        showMasInfoUsuario: false,
        alert: undefined
    }

    render() {
        const {misAutorizaciones, misUsuarios} = this.props;
        const soyUserAdmin = tengoRol([Role.USER_ADMIN]);

        const header = [
            {title: 'Username', field: 'username'},
            {title: 'Nombre', field: 'nombre'},
            {title: 'Mail', cellStyle: {width: '10%'}, field: 'mail'},
            {
                title: 'Fecha', field: 'dateCreated',
                render: row =>
                    <Moment date={row.dateCreated} format="DD/MM/YYYY hh:mm"/>
            },
            {
                title: 'Habilitado', field: 'enabled',
                render: row =>
                    row.enabled ? 'Si' : 'No'
            },
            {
                title: 'Roles', field: 'enabled',
                render: row =>
                    <>
                        {row.roles?.map((item, index) =>
                            <span>{authService.formatRol(item.authority)}</span>
                        )}
                    </>
            },
            {
                title: 'Acciones', cellStyle: {width: '30%'},
                render: row =>
                    <>
                        {row.roles?.some(it => it.id === RoleID.USER) &&
                        <button className="btns btns-link" onClick={() => this.asignarEquipo(row)}>
                            <span className="material-icons text-fucsia">add</span></button>}
                    </>
            }
        ];

        const options = {
            search: true,
            sorting: true
        }

        let inic = {
            nombre: ''
        }

        return (
            <div className="main-content">
                <Container fluid>

                    {(soyUserAdmin) && <Row>
                        <Col sm={12}>
                            <button className="btns btns-iot text-dark" variant="primary"
                                    onClick={() => this.handleMasInfo(undefined)}>
                                <span className="material-icons material-icons-outlined">forum</span> Agregar usuario
                            </button>
                        </Col>
                    </Row>}
                    <br/>
                    <Row>
                        <Col>
                            <div className="mt-5">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={inic}
                                    onSubmit={(values) => {
                                        this.setState({
                                            values: values
                                        }, this.actualizar);
                                    }}>
                                    {({values, setFieldValue}) => (
                                        <Form>
                                            <Row className="justify-content-center">
                                                <Col lg={6} xs={12}>
                                                    <label htmlFor="Estado">
                                                        Nombre / Email
                                                    </label>
                                                    <Field name='nombre'/>
                                                </Col>
                                            </Row>
                                            <Row className="justify-content-center mb-4">
                                                <Col xs={12} lg={3}
                                                     className="mt-4 d-flex justify-content-lg-end justify-content-sm-center">
                                                    <button className="btn-block btns-primary btns" type="submit"><i
                                                        className="fas fa-search"></i> Buscar
                                                    </button>
                                                </Col>
                                            </Row>
                                        </Form>

                                    )}
                                </Formik>
                            </div>
                            <hr></hr>
                        </Col>
                    </Row>
                    <Row className="row mb-5">
                        <Col sm={12}>
                            <MaterialTable
                                title='Usuarios de mi empresa'
                                columns={header}
                                tableRef={tableRef4}
                                data={query =>
                                    this.buscarData(query, false)
                                }
                                options={options}
                                localization={utilActions.traerPalabrasTabla()}
                                detailPanel={rowData => {
                                    return (
                                        <UserDP rowData={rowData} onDelete={this.onDelete}/>
                                    )
                                }}
                                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            />
                        </Col>
                    </Row>
                </Container>

                {this.state.showEquipo &&
                <FormAsignarEquipoUsuario show={this.state.showEquipo} usuario={this.state.usuario}
                                          handleClose={this.handleClose}/>}

                {this.state.showUsuario &&
                <FormUsuarioAdmin show={this.state.showUsuario} handleClose={this.handleClose}
                                  usuario={this.state.usuario}/>}
                {this.state.alert}
            </div>
        );
    }
}

function mapState(state) {
    const {misAutorizaciones, misUsuarios} = state.grupo;
    return {misAutorizaciones, misUsuarios};
}

const actionCreators = {
    asignarRol: grupoActions.asignarRol,
    eliminarRol: grupoActions.eliminarRol,
    reasignarRol: grupoActions.reasignarRol,
    eliminarUsuario: grupoActions.eliminarUsuario,
    enviarSuccess: alertActions.success
}

const connectedMisUsuarios = connect(mapState, actionCreators)(MisUsuarios);
export {connectedMisUsuarios as MisUsuarios};
